import { HttpErrorResponse } from '@angular/common/http';
import { CreateSpacePayload, Space } from '@innovation-os-ng/core/models';
import { createAction, props, union } from '@ngrx/store';
import { SPACE_PREFIX } from '../constants';

/**
 * GETTING AVAILABLE SPACES
 */
const fetchAvailableSpacesByTenantUri = createAction(`${SPACE_PREFIX} Fetch available spaces by tenant uri`, props<{ tenantUri: string }>());
const fetchAvailableSpacesByTenantSlug = createAction(
  `${SPACE_PREFIX} Fetch available spaces by tenant slug`,
  props<{ tenantSlug: string }>()
);
const fetchAvailableSpacesByCurrentTenant = createAction(`${SPACE_PREFIX} Fetch available spaces by current tenant`);

const fetchAvailableSpacesSuccess = createAction(
  `${SPACE_PREFIX} Fetch available spaces Success`,
  props<{ tenantUri?: string; newSpaces: Array<Space> }>()
);
const fetchAvailableSpacesError = createAction(`${SPACE_PREFIX} Fetch available spaces Error`, props<{ error: HttpErrorResponse }>());

/**
 * SETTING CURRENT SPACE
 */
const setCurrentSpaceUri = createAction(`${SPACE_PREFIX} Set current space uri`, props<{ spaceUri: string }>());
const setCurrentSpace = createAction(`${SPACE_PREFIX} Set current space`, props<{ space: Space }>());


const replaceUpdatedSpace = createAction(`${SPACE_PREFIX} Replace updated space`,  props<{ updatedSpace: Space }>());

/**
 * CREATING SPACE
 */
const createSpace = createAction(`${SPACE_PREFIX} Create space`, props<{ spacePayload: CreateSpacePayload }>());
const setCreateSpaceSuccess = createAction(`${createSpace.type} Success`, props<{ space: Space }>());
const setCreateSpaceError = createAction(`${createSpace.type} Error`, props<{ error: HttpErrorResponse }>());

/**
 * DELETING SPACE
 */
const deleteSpace = createAction(`${SPACE_PREFIX} Delete space`, props<{ spaceUri: string }>());
const setDeleteSpaceSuccess = createAction(`${deleteSpace.type} Success`, props<{ spaceUri: string }>());
const setDeleteSpaceError = createAction(`${deleteSpace.type} Error`, props<{ error: HttpErrorResponse }>());

const selectNextAvailableSpace = createAction(`${SPACE_PREFIX} Select next available space`, props<{ deletedSpaceUri?: string }>());

/**
 * UPDATING SPACE
 */
const updateSpace = createAction(`${SPACE_PREFIX} Update space`, props<{ space: Space }>());
const setUpdateSpaceSuccess = createAction(`${updateSpace.type} Success`, props<{ space: Space }>());
const setUpdateSpaceError = createAction(`${updateSpace.type} Error`, props<{ error: HttpErrorResponse }>());



const reset = createAction(`${SPACE_PREFIX} Reset`);

const all = union({
  fetchAvailableSpacesByTenantUri,
  fetchAvailableSpacesByTenantSlug,
  fetchAvailableSpacesByCurrentTenant,
  fetchAvailableSpacesSuccess,
  fetchAvailableSpacesError,
  createSpace,
  setCreateSpaceSuccess,
  setCreateSpaceError,
  setCurrentSpaceUri,
  setCurrentSpace,
  replaceUpdatedSpace,
  deleteSpace,
  setDeleteSpaceSuccess,
  setDeleteSpaceError,
  selectNextAvailableSpace,
  updateSpace,
  setUpdateSpaceSuccess,
  setUpdateSpaceError,
  reset
});
// exporting the type of actions here to make sure that we can use the correct type in effects
export type SpaceActionTypes = typeof all;

export const SpaceActions = {
  fetchAvailableSpacesByTenantUri,
  fetchAvailableSpacesByTenantSlug,
  fetchAvailableSpacesByCurrentTenant,
  fetchAvailableSpacesSuccess,
  fetchAvailableSpacesError,
  createSpace,
  setCreateSpaceSuccess,
  setCreateSpaceError,
  setCurrentSpaceUri,
  setCurrentSpace,
  replaceUpdatedSpace,
  deleteSpace,
  setDeleteSpaceSuccess,
  setDeleteSpaceError,
  selectNextAvailableSpace,
  updateSpace,
  setUpdateSpaceSuccess,
  setUpdateSpaceError,
  reset
};
